<script lang="ts" setup>
export interface FlashNewsArticleProps {
    article: FlashNewsArticle
    headingLevel: string
}

const props = defineProps<FlashNewsArticleProps>()
const { data, sendEvent } = useTracker()

const handleClick = (): void => {
    sendEvent({
        data: {
            ...data,
            click: props.article.url,
        },
    })
}
</script>
<template>
  <article>
    <ArticleDate
      class="mb-1"
      :date="props.article.published_at"
    />
    <Heading
      class="text-black fs-normal fw-bolder mb-0"
      :level="props.headingLevel"
    >
      <a
        v-if="props.article.isExternal"
        :href="props.article.url"
        class="text-black"
        target="_blank"
        @click="handleClick"
      >
        {{ props.article.title }}
      </a>
      <VNuxtLink
        v-else
        class="text-black"
        :to="`/${props.article.url}`"
        :label="props.article.url"
      >
        {{ props.article.title }}
      </VNuxtLink>
    </Heading>
  </article>
</template>
